/**
 * 菜单面包屑配置
 * 由大搜车统一工作台配置
 * title:菜单名
 * link:路径
 * subMenus:子路由
 * */
import { getState } from '@@/store';
import { notification } from 'antd';
// 路由权限 - 权限路由都需配置，无权限无需配置
const powerData = JSON.parse(JSON.stringify({
    '/home': 'psgjb-home-first',
    '/ApproveManage': 'psgjb-approvemanage-first',
    '/ApproveManage/AllApproveManage': 'psgjb-carpend-enter',
    '/ApproveManage/AllApproveManage/CreateSession': 'psgjb-carthrough-foundsession',
    '/ApproveManage/MyApproveManage': 'psgjb-carpendmine-enter',
    '/CarManage': 'psgjb-carpend-first',
    '/auction': 'psgjb-auctionsale-first',
    '/auction/bidManage': 'psgjb-jpgl-enter',
    '/auction/sceneManage': 'psgjb-auctionmanage-enter',
    '/auction/sceneManage/SessionEdit': 'psgjb-auctionmanadone-edit',
    '/auction/sceneManage/SessionDetail': 'psgjb-auctionmanadone-view',
    '/auction/sceneManage/auctioneer': 'psgjb-auctionmanadone-auction',
    '/auction/sceneManage/screen': 'psgjb-auctionmanadone-project',
    '/auction/sceneManage/AddPrice': 'psgjb-auctionmanadone-markup',
    '/OrderManage': 'psgjb-ordercontractsign-first',
    '/OrderManage/ConfirmTransferInfo': '',
    '/OrderManage/WaitTransfer': '',
    '/OrderManage/WinBiddingCar': 'psgjb-ordercontractsign-enter',
    '/OrderManage/WaitSignContract': 'psgjb-ordercontractsign-enter',
    '/OrderManage/WaitPayCar': 'psgjb-orderobili-enter',
    '/OrderManage/WaitTransferCar': 'psgjb-ordertransfer-enter',
    '/OrderManage/SuccessTrade': 'psgjb-ordervolume-enter',
    '/OrderManage/DealFailCar': 'psgjb-orderfail-enter',
    '/OrderManage/DisputeManage': 'psgjb-orderdispute-enter',
    '/finance': 'psgjb-finanbuydepo-first',
    '/finance/moneyManage/buyermargin': 'psgjb-finanbuydepo-enter',
    '/finance/moneyManage/buyermargin/detail': 'psgjb-finanbupayment-view',
    '/finance/moneyManage/sellermargin': 'psgjb-finansedepo-enter',
    '/finance/moneyManage/sellermargin/detail': 'psgjb-finansepayment-view',
    '/finance/payManage': 'psgjb-finanpayment-enter',
    '/finance/cashManage': 'psgjb-finanwithdraw-enter',
    '/finance/GroupMoneyManage': 'psgjb-finanjtbzjgl-enter',
    '/finance/GroupAccountManage': 'psgjb-finanjtzhgl-enter',
    '/dealerManage': 'psgjb-dealerbusell-first',
    '/dealerManage/seller': 'psgjb-dealerseller-enter',
    '/dealerManage/buyer': 'psgjb-dealerbuyer-enter',
    '/account': 'psgjb-sysdispuset-first',
    '/operating': 'psgjb-opeimageset-first',
    '/operating/CarouseSet': 'psgjb-opeimageset-first',
    '/operating/CompanySet': 'psgjb-opeimageset-first',
    '/operating/MarketingTools': 'psgjb-yxgj-enter',
    '/System': 'psgjb-sysdispuset-first',
    '/System/auctionRules': 'psgjb-sysruleset-enter',
    '/System/argueRules': 'psgjb-sysdispuset-enter',
    '/System/SellerPayRules': 'psgjb-mjjs-enter',
    '/BidManage': 'psgjb-jpgl-first',
    '/BidManage/SessionList': 'psgjb-jpgl-enter',
    '/BidManage/SessionList/bidDetail': ['psgjb-jpglxcp-edit', 'psgjb-jpglapcc-edit'],
    '/DataStatistics': 'psgjb-datastatistics-first',
    '/DataStatistics/ReportList': 'psgjb-datareportlist-enter',
    '/DataStatistics/Overview': 'psgjb-dataoverview-enter',
    '/DataStatistics/Analysis': 'psgjb-analysis-enter',
}).toLowerCase());
// 菜单面包屑 - 仅需配置三级菜单所需数据
const menuList = JSON.parse(JSON.stringify({
    '/CarManage': {
        '/OfferCeneList': '/竞拍记录',
        '/Deal': '/处理',
        '/DealDetail': '/处理详情',
        '/RealtimeMonitoring': '/实时监控',
        '/OfferDetails': '/出价详情',
        '/CreateSession': '/发拍场次设置',
    },
    '/ApproveManage/AllApproveManage': {
        '/CreateSession': '/发拍场次设置',
    },
    '/finance/moneyManage/sellermargin': {
        '/detail': '/卖家保证金详情',
    },
    '/finance/moneyManage/buyermargin': {
        '/detail': '/买家保证金详情',
    },
    '/auction/sceneManage': {
        '/SessionEdit': '/场次编辑',
        '/SessionDetail': '/场次详情',
        '/auctioneer': '/拍卖师',
        '/screen': '/联播场次投屏页',
        '/AddPrice': '/加价师',
        '/SessionPrint': '/场次打印',
    },
    '/auction/BidManage/SessionList': {
        '/BidDetail': '/场次数据详情',
    },
    '/OrderManage/ConfirmTransferInfo': {
        '/ConfirmTransferInfo': '/确认过户信息',
        '/WaitTransfer': '/待过户',
    },
    '/finance/groupAccountManage': {
        '/accountDetail': '/账户详情',
    },
    '/DataStatistics/ReportList': {
        '/ReportCreate': '/新建报表',
    },
}).toLowerCase());
// 处理路由数据
const breadPowerData = {};
const dealMenuData = (routeData, pathList, breadList) => {
    const routeList = routeData;
    routeData.forEach((v, i) => {
        const routeItem = v;
        const dealName = `${breadList.join('/')}/${v.title}`;
        const breadName = breadList.length > 0 ? dealName : `/${v.title}`;
        if (!v.link || v.link === '') {
            if (v.subMenus.length > 0) {
                const childLink = v.subMenus[0].link.split('/')[1];
                v.link = `/${childLink}`;
            }
            else {
                v.link = '/routeConfigError';
                notification.warn({
                    message: '菜单配置出错',
                    description: `错误菜单为：${v.title}`,
                });
            }
        }
        const lowerLink = v.link.toLowerCase();
        breadPowerData[lowerLink] = breadName;
        const thirdMenu = menuList[lowerLink];
        if (thirdMenu) {
            Object.keys(thirdMenu).forEach((x) => {
                const parent = breadPowerData[lowerLink];
                breadPowerData[`${lowerLink}${x}`] = `${parent}${thirdMenu[x]}`;
            });
        }
        if (v.subMenus && v.subMenus.length > 0) {
            pathList.push(v.link);
            breadList.push(breadName);
            const delArray = dealMenuData(v.subMenus, pathList, breadList);
            routeItem.subMenus = delArray.filter((q) => (q !== null));
        }
        if (v.link === pathList.join('')) {
            pathList.pop();
            breadList.pop();
        }
    });
    return routeList;
};
export const powerListData = powerData;
export const getPowerMenu = () => {
    const menuData = getState().global.menus;
    const menu = dealMenuData(menuData, [], []);
    return {
        menu,
        bread: breadPowerData,
    };
};
